import { atom } from "recoil";
import { AtomKeys } from "stores/storeKeys";

/**
 * 確認モーダル
 */
export type ModalConfirmStateType = {
  open: boolean;
  title: string | null;
  message: string;
  onSubmit: () => void;
};

export const ModalConfirmState = atom<ModalConfirmStateType>({
  key: AtomKeys.MODAL_CONFIRME_STATE,
  default: {
    open: false,
    title: null,
    message: "",
    onSubmit: () => {
      return;
    },
  },
});
